import PropTypes from 'prop-types';
import React from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import { SILVER_SAND } from '@wetransfer/transfer/constant/colors';
import Browser from '@wetransfer/transfer/modules/concorde-browser';

const Accordion = ({ items }) => {
  if (items.length <= 0) {
    return null;
  }

  const openItem = (event) => {
    // find the item
    const item = event.currentTarget;

    if (item.className.indexOf('accordion__item--is-open') === -1) {
      item.className = 'accordion__item accordion__item--is-open';
    } else {
      item.className = 'accordion__item';
    }
  };

  function renderElementOrHTML(type, props, children) {
    if (children instanceof Element) {
      props = {
        ...props,
        dangerouslySetInnerHTML: { __html: children.innerHTML },
      };
      children = null;
    }
    const CustomElementTag = type;

    return <CustomElementTag {...props}>{children}</CustomElementTag>;
  }

  const makeItems = (items) => {
    const markup = items.map((item, index) => {
      // eslint-disable-next-line testing-library/render-result-naming-convention
      const title = renderElementOrHTML('h5', {}, item.title);

      const shortDescription = item.shortDescription
        ? renderElementOrHTML('p', {}, item.shortDescription)
        : null;

      // eslint-disable-next-line testing-library/render-result-naming-convention
      const content = renderElementOrHTML(
        'div',
        { className: 'accordion__item-content' },
        item.content
      );

      const icon = item.icon ? (
        <span className="accordion__item-header-icon">{item.icon}</span>
      ) : null;

      return (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        <li
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && openItem(e)}
          onClick={openItem}
          className="accordion__item"
          key={index}
        >
          <div className="accordion__item-header">
            {icon}
            <span className="accordion__item-header-content">
              {title}
              {!Browser.isMobile && shortDescription ? shortDescription : null}
            </span>
            <span className="accordion__item-header-action">
              <Icon type="Arrow" color={SILVER_SAND} orientation="bottom" />
            </span>
          </div>
          {content}
        </li>
      );
    });

    return <ul className="accordion__container">{markup}</ul>;
  };

  return <div className="accordion">{makeItems(items)}</div>;
};

Accordion.propTypes = {
  items: PropTypes.array,
};

Accordion.defaultProps = {
  items: [],
};

export default Accordion;
